import Vue from "vue";
import Router from "vue-router";
import routes from './routes';
Vue.use(Router);

// 创建路由
const router = new Router({
	scrollBehavior: () => ({ y: 0 }),
	routes: routes
});

// 路由拦截
router.beforeEach((to, from, next) => {
    // next()
    // return
	if(to.path === '/login'){
		if(localStorage.getItem('token')){
			next({ name: 'Thome', })
		}else{
			next()
		}
	}else{
		if (to.path.startsWith('/box') || to.meta.requiresAuth){ //是box开头,说明需要校验token	
			if(!localStorage.getItem('token')){
				next({path: '/login'})
			}else{
				if (to.path.startsWith('/projectManagement')){ //如果去的是项目管理，校验是否有权限
					const state = localStorage.getItem("projectManagementRule");
					const projectTelphoneList = JSON.parse(localStorage.getItem("projectTelphoneList")) || [];
					const userTelphone = JSON.parse(localStorage.getItem("data")).data.user.telephone
					if (state === 'true' || state === true || projectTelphoneList.includes(userTelphone)) {
						next();
					}else{
						next('/404');
					}
				}else{
					next()
				}
			}
		}else{
			next()
		}
	}
    
});

export default router
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
